import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/features/array/includes";
import "core-js/features/string/includes";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Dedupe as DedupeIntegration } from "@sentry/integrations";
import * as serviceWorker from "./serviceWorker";
import React from "react";

import("@sentry/browser").then((Sentry) =>
  Sentry.init({
    dsn: "https://baf6bcb4e6ac4efeb30632b56345ac6b@sentry.io/2035715",
    environment: document.location.hostname,
    release: `naf-kjopekontrakt@${process.env.REACT_APP_VERSION}`,
    debug: document.location.hostname.includes("localhost"),
    integrations: [new DedupeIntegration()],
    ignoreErrors: ["Non-Error promise rejection captured"],
  })
);

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(<App />, rootElement);
} else {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
